
// Simplified arXiv categories with only main categories that return results
export const ARXIV_CATEGORY_GROUPS = [
  {
    name: 'Computer Science',
    categories: [
      { value: 'cs', label: 'Computer Science (All)' }
    ]
  },
  {
    name: 'Mathematics',
    categories: [
      { value: 'math', label: 'Mathematics (All)' }
    ]
  },
  {
    name: 'Physics',
    categories: [
      { value: 'physics', label: 'Physics (All)' },
      { value: 'astro-ph', label: 'Astrophysics' },
      { value: 'cond-mat', label: 'Condensed Matter' },
      { value: 'gr-qc', label: 'General Relativity and Quantum Cosmology' },
      { value: 'hep-ex', label: 'High Energy Physics - Experiment' },
      { value: 'hep-lat', label: 'High Energy Physics - Lattice' },
      { value: 'hep-ph', label: 'High Energy Physics - Phenomenology' },
      { value: 'hep-th', label: 'High Energy Physics - Theory' },
      { value: 'math-ph', label: 'Mathematical Physics' },
      { value: 'nlin', label: 'Nonlinear Sciences' },
      { value: 'nucl-ex', label: 'Nuclear Experiment' },
      { value: 'nucl-th', label: 'Nuclear Theory' },
      { value: 'quant-ph', label: 'Quantum Physics' }
    ]
  },
  {
    name: 'Quantitative Biology',
    categories: [
      { value: 'q-bio', label: 'Quantitative Biology (All)' }
    ]
  },
  {
    name: 'Quantitative Finance',
    categories: [
      { value: 'q-fin', label: 'Quantitative Finance (All)' }
    ]
  },
  {
    name: 'Statistics',
    categories: [
      { value: 'stat', label: 'Statistics (All)' }
    ]
  },
  {
    name: 'Economics',
    categories: [
      { value: 'econ', label: 'Economics (All)' }
    ]
  },
  {
    name: 'Electrical Engineering and Systems Science',
    categories: [
      { value: 'eess', label: 'EESS (All)' }
    ]
  }
];

// Flattened list for backwards compatibility
export const ARXIV_CATEGORIES = ARXIV_CATEGORY_GROUPS.flatMap(group => group.categories);
